@let brandCopy = cmsService.brandDataComponentCopy();
@let appCommonCopy = cmsService.appCommonPageCopy();
@if (
  featureFlagService.isFeatureActive(FeatureFlagEnum.BROCHURE_SITE) &&
  brandCopy &&
  appCommonCopy
) {
  @let headerMenuCopy = cmsService.headerMenuComponentCopy();
  @let robynByFeazelImage =
    appCommonCopy.images?.['robynByFeazel']?.desktopImage;
  <header class="fluid-container mb-3">
    <nav
      class="navbar navbar-expand-lg bg-body-tertiary"
      aria-label="Main navigation"
    >
      <div class="container">
        <div class="align-items-center d-flex">
          <button
            class="navbar-toggler border-0"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mainNav"
            aria-controls="mainNav"
            aria-label="Open menu"
            data-qa="mobile-nav"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <a class="d-inline-flex" routerLink="/" aria-label="Navigate home">
            <img
              class="logo-header-menu"
              [src]="brandCopy.images.logo.desktopImage.url"
              [alt]="brandCopy.images.logo.desktopImage.altText"
            />
          </a>
        </div>

        <div
          class="offcanvas offcanvas-end offcanvas-lg"
          tabindex="-1"
          id="mainNav"
          aria-labelledby="mainNavLabel"
        >
          <div class="offcanvas-header d-lg-none">
            <div
              class="d-flex flex-column flex-grow-1 justify-content-center align-items-center"
            >
              <a class="d-flex" routerLink="/" aria-label="Navigate home">
                <img
                  class="logo-header-offcanvas"
                  [src]="brandCopy.images.logo.desktopImage.url"
                  [alt]="brandCopy.images.logo.desktopImage.altText"
                />
              </a>
              <div class="d-flex contact-actions mt-2">
                <div
                  class="d-flex justify-content-center align-items-center contact-phone"
                >
                  <a
                    class="btn btn-link link-only"
                    [href]="brandCopy.phoneNumber | phoneHref"
                    [attr.aria-label]="
                      'Call us at ' + (brandCopy.phoneNumber | phoneMask)
                    "
                  >
                    {{ brandCopy.phoneNumber | phoneMask }}
                  </a>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <button
                    #fabBtnMobile
                    class="btn btn-link link-only"
                    data-qa="robyn-contact"
                    (click)="contactService.openFab(fabBtnMobile)"
                  >
                    @if (robynByFeazelImage) {
                      <img
                        class="robyn-logo"
                        [src]="robynByFeazelImage.url"
                        [alt]="robynByFeazelImage.altText"
                      />
                    }
                    {{ appCommonCopy?.['robynContactMeCta'] ?? 'Contact me' }}
                  </button>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn-close color-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close menu"
            ></button>
          </div>

          <div class="offcanvas-body">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              @for (column of headerMenuCopy?.columns; track $index) {
                <li class="nav-item dropdown">
                  @for (menu of column; track $index) {
                    <a
                      class="nav-link dropdown-toggle no-caret-desktop"
                      href="#"
                      [id]="menu.headerItem.label"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ menu.headerItem.label }}
                    </a>
                    <ul
                      class="dropdown-menu"
                      [attr.aria-labelledby]="menu.headerItem.label"
                    >
                      @for (link of menu.menuItems; track $index) {
                        <li>
                          @let dataQa =
                            'header-nav-'+(link.label?.replace(/\s+/g, '-'))?.toLowerCase();
                          <app-link
                            [inputLink]="link"
                            [inputCss]="'dropdown-item'"
                            [inputAriaLabel]="link.label"
                            [inputDataQa]="dataQa"
                          ></app-link>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
        <div class="d-flex contact-actions">
          <div
            class="d-flex justify-content-center align-items-center contact-phone"
          >
            <a
              class="btn btn-link link-only"
              [href]="brandCopy.phoneNumber | phoneHref"
              [attr.aria-label]="
                'Call us at ' + (brandCopy.phoneNumber | phoneMask)
              "
            >
              {{ brandCopy.phoneNumber | phoneMask }}
            </a>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <button
              #fabBtn
              class="btn btn-link link-only"
              data-qa="robyn-contact"
              (click)="contactService.openFab(fabBtn)"
            >
              @if (robynByFeazelImage) {
                <img
                  class="robyn-logo"
                  [src]="robynByFeazelImage.url"
                  [alt]="robynByFeazelImage.altText"
                />
              }
              {{ appCommonCopy?.['robynContactMeCta'] ?? 'Contact me' }}
            </button>
          </div>
        </div>
      </div>
    </nav>
  </header>
} @else {
  <header class="fluid-container py-2 mb-3">
    <div class="container">
      <div class="row">
        <div class="col">
          @if (brandCopy) {
            <a [href]="brandCopy.url" aria-label="Navigate home">
              <img
                class="logo-header"
                [src]="brandCopy.images.logo.desktopImage.url"
                [alt]="brandCopy.images.logo.desktopImage.altText"
              />
            </a>
          }
        </div>
      </div>
    </div>
  </header>
}
